
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

try {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} catch (error) {
  console.error("Fatal: App failed to mount", error);
  rootElement.innerHTML = `
    <div style="height: 100vh; display: flex; align-items: center; justify-content: center; background: #050505; color: white; font-family: sans-serif; text-align: center; padding: 20px;">
      <div>
        <h1 style="color: #39ff14; font-size: 24px;">Initialization Failed</h1>
        <p style="opacity: 0.5; margin-top: 10px;">A critical error occurred during startup.</p>
        <button onclick="localStorage.clear(); window.location.reload();" style="margin-top: 20px; padding: 10px 20px; background: #39ff14; color: black; border: none; border-radius: 8px; font-weight: bold; cursor: pointer;">
          Reset Settings & Retry
        </button>
      </div>
    </div>
  `;
}
